<template>
  <div :class="[active?'active-grasimi':'']">
    <div class="row height-row" @click="active=!active" data-toggle="collapse" data-target="#grasimi2">
      <div class="col-md-4 col-4 border-table">
        <span v-if="!active" class="plus">+</span>
        <span v-else class="minus">-</span>
        <span class="span-black pl-0">Grasimi, din care</span>
      </div>
      <div class="col-md-4 col-4 border-table"><span class="span-black">22 g</span></div>
      <div class="col-md-4 col-4 border-table border-last"><span class="span-black">3.2 g</span></div>

    </div>

    <div id="grasimi2" class="collapse">
      <div class="row  height-row">
        <div class="col-md-4 col-4 border-table"><span class="span-blue">Acizi grasi saturati</span></div>
        <div class="col-md-4 col-4 border-table"><span class="span-blue">7.2 g</span></div>
        <div class="col-md-4 col-4 border-table border-last"><span class="span-blue">1.0 g</span></div>
      </div>

      <div class="row  height-row">
        <div class="col-md-4 col-4 border-table"><span class="span-blue">Acizi grași mononesaturați</span></div>
        <div class="col-md-4 col-4 border-table"><span class="span-blue">11.2 g</span></div>
        <div class="col-md-4 col-4 border-table border-last"><span class="span-blue">1.6 g</span></div>
      </div>

      <div class="row  height-row">
        <div class="col-md-4 col-4 border-table"><span class="span-blue">Acizi grași polinesaturați</span></div>
        <div class="col-md-4 col-4 border-table"><span class="span-blue">3.8 g</span></div>
        <div class="col-md-4 col-4 border-table border-last"><span class="span-blue">0.5 g</span></div>
      </div>

      <div class="row  height-row">
        <div class="col-md-4 col-4 border-table"><span class="span-blue">Acid arahidonic (AA) (omega-6)</span></div>
        <div class="col-md-4 col-4 border-table"><span class="span-blue">0.06 g</span></div>
        <div class="col-md-4 col-4 border-table border-last"><span class="span-blue">0.0088 g</span></div>
      </div>
      <div class="row  height-row">
        <div class="col-md-4 col-4 border-table"><span class="span-blue">Acid docosahexaenoic (DHA) (omega-3)</span></div>
        <div class="col-md-4 col-4 border-table"><span class="span-blue">0.12 g</span></div>
        <div class="col-md-4 col-4 border-table border-last"><span class="span-blue">0.017 g</span></div>
      </div>
      <div class="row  height-row">
        <div class="col-md-4 col-4 border-table"><span class="span-blue">Acid eicosapentaenoic (EPA) (omega-3)</span></div>
        <div class="col-md-4 col-4 border-table"><span class="span-blue">0.03 g</span></div>
        <div class="col-md-4 col-4 border-table border-last"><span class="span-blue">0.0036 g</span></div>
      </div>
      <div class="row  height-row">
        <div class="col-md-4 col-4 border-table"><span class="span-blue">Acid linoleic (LA) (omega-6)</span></div>
        <div class="col-md-4 col-4 border-table"><span class="span-blue">3.0 g</span></div>
        <div class="col-md-4 col-4 border-table border-last"><span class="span-blue">0.435 g</span></div>
      </div>
      <div class="row  height-row">
        <div class="col-md-4 col-4 border-table"><span class="span-blue">Acid alfa-linolenic (omega-3)</span></div>
        <div class="col-md-4 col-4 border-table"><span class="span-blue">0.36 g</span></div>
        <div class="col-md-4 col-4 border-table border-last"><span class="span-blue">0.0523 g</span></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "grasimi",
  data() {
    return {
      active: false
    }
  }
}
</script>

<style>
.active-grasimi {
  background: #F8F8F8;
}
</style>
